import Icon from './Icon.container';

export default Icon;
